
















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptCommodityAnalyse extends Vue {

  // 商品分析表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public closingDateFrom: Date = null;
  public closingDateTo: Date = null;
  public segment: Common.Segment = null;
  public commodityCategory: Common.Category = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public onExcelExport :boolean = false;
  public closingDateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public closingDateToFlag : Common.dateFlags = Common.dateFlags.default;

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.CommodityAnalyseReportTemplateQuery = new Common.CommodityAnalyseReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    var today = new Date().getCalendarDate();
    this.closingDateFrom = today;
    this.closingDateTo = today;
    (this.$refs.CommodityAnalyseDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.CommodityAnalyseReportQuery = new Common.CommodityAnalyseReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.closingDateFrom = new Date(this.closingDateFrom.getFullYear(),this.closingDateFrom.getMonth() +1,0).getCalendarDate();
    query.closingDateTo = new Date(this.closingDateTo.getFullYear(),this.closingDateTo.getMonth() +1,0).getCalendarDate();
    query.segment = this.segment;
    query.commodityCategory = this.commodityCategory;
    query.onExcelExport = this.onExcelExport;
    this.$api.download(query);
  }
}
